export enum UserTypes  {
    ADMIN = "ADMIN",
    REGULAR = "REGULAR",
  }
  